<template>
  <div class="form-group row">
    <label class="col-sm-3 col-form-label">{{ label }}</label>
    <div class="col-sm-6">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: "",
    },
  },
};
</script>
